import { FC } from "react";

import { SecondaryOverlay } from "components/constants";
import { t } from "i18n/i18n";
import { Button } from "mds/components/Button";
import { IconText } from "mds/components/IconText";
import { MenuItem } from "mds/components/Menu";
import { PersonClassIcon } from "mds/icons";
import { useOverlayControls } from "utils/routing/hooks/use-overlay-controls";

export const UserPanelToggleButton: FC<{ isMenuItem?: boolean }> = ({ isMenuItem = false }) => {
  const { isSelected, togglePanel } = useOverlayControls(SecondaryOverlay.Users);

  if (isMenuItem) {
    return (
      <MenuItem
        eventName="Section Users - Toggle"
        eventProps={{ isOpened: !isSelected }}
        onClick={togglePanel}
      >
        <IconText iconStart={<PersonClassIcon />} text={t("content_sidebar.title.Users")} />
      </MenuItem>
    );
  }

  return (
    <Button
      eventName="Section Users - Toggle"
      eventProps={{ isOpened: !isSelected }}
      isSelected={isSelected}
      kind="squareLegacy"
      size="l"
      title={t("content_sidebar.title.Users")}
      isSquare
      onClick={togglePanel}
    >
      <PersonClassIcon />
    </Button>
  );
};
